/*
 * @Author: 汪俊洪
 * @Date: 2022-06-22 09:11:11
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2022-06-22 17:23:38
 * @Description: 前端导出excel
 */
export const tableToExcel = ({ data, titles, fileName = '下载.xls' }) => {
  // 添加表头 开始
  let str = '<tr>'
  const keys = Object.keys(titles)
  keys.forEach((key) => {
    str += `<th>${titles[key] + '\t'}</th>`
  })
  str += '</tr>'
  // 添加表头 结束
  // 添加内容 开始
  data.forEach((v) => {
    str += '<tr>'
    keys.forEach((key) => {
      str += `<td>${v[key] || '' + '\t'}</td>`
    })
    str += '</tr>'
  })
  // 添加内容 结束
  // Worksheet名
  const worksheet = 'Sheet1'
  const uri = 'data:application/vnd.ms-excel;base64,'

  // 下载的表格模板数据
  const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" 
    xmlns:x="urn:schemas-microsoft-com:office:excel" 
    xmlns="http://www.w3.org/TR/REC-html40">
    <head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
    <x:Name>${worksheet}</x:Name>
    <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
    </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
    </head><body><table>${str}</table></body></html>`
  // 下载模板
  const elink = document.createElement('a')
  elink.download = fileName
  elink.style.display = 'none'
  elink.href = uri + base64(template)
  document.body.appendChild(elink)
  elink.click()
  URL.revokeObjectURL(elink.href) // 释放URL 对象
  document.body.removeChild(elink)
}

// 输出base64编码
const base64 = (s) => window.btoa(unescape(encodeURIComponent(s)))
